import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import React, { useCallback, useEffect, useState } from "react";
import { Text } from "./../Components/Text";
import { themeDefault } from "src/theme-revamp";
import { useDispatch } from "react-redux";
import Button from "@components/_Revamp/Button";
import { useAvivaSelector } from "@redux/hook";
import { isEmpty } from "lodash";
import { Helpers } from "@utils/helpers";
import { useHistory, useLocation } from "react-router-dom";
import Contactus from "@components/_Shared/Contactus";
import Icon from "@components/_Revamp/Icon";
import { SHIELD_STARTER_HELTH_PLUS } from "@static/staticConstents";
import { ROUTE_PATH } from "@static/route-paths";
import MainContainer from "../Components/Container";
import { setLoadingState } from "@redux/slices/loadingSlice";
import { checkPaymentSuccess } from "@api/index";
import { trackOnLoad } from "../Helpers/dataAnalyticsHelpers";
import { FinancialAdviser } from "@redux/slices/SHIELD_STARTER/step4Slice";
import { AA as AAShieldStarter } from "@utils/adobeAnalyticsSS";
import { updatePaymentStatus } from "@redux/slices/SHIELD_STARTER/step5Slice";
import { HOME_URL, UTM_CANCER_URL, UTM_CARESHIELD_URL } from "@static/config";

const Confirmation = () => {
  const search = useLocation().search;
  const params = new URLSearchParams(search);
  const advisor = params.get("advisor");
  const history = useHistory();
  const dispatch = useDispatch();
  const [planSummary, setPlanSummary] = useState<any>([]);
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [showPage, setShowPage] = useState(false);

  const policyName = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const planOverview = useAvivaSelector(
    (state) => state.shieldStarterStep2.planOverview
  );
  const paymentRef = useAvivaSelector(
    (state) => state.shieldStarterStep5.paymentRef
  );
  const step1data = useAvivaSelector((state) => state.shieldStarterStep1);
  const shieldStarterStep3 = useAvivaSelector(
    (state) => state.shieldStarterStep3
  );
  //checking if the selected child data is available, if avaialble assuming policy is bought for the child.
  const policyHolderDetail: any = isEmpty(shieldStarterStep3.selectedChildInfo)
    ? shieldStarterStep3.personalInfo
    : shieldStarterStep3.selectedChildInfo;
  const { agentCode, autoAssignAgent }: any = useAvivaSelector(
    (state) => state.shieldStarterStep4
  );
  const selectedPlanName = policyName === SHIELD_STARTER_HELTH_PLUS ?"Shield Starter and Singlife Health Plus Starter":"Shield Starter"
  const infoData = [
    {
      num: "1",
      text: "You'll receive an email confirmation about your application within 5 working days.",
    },
    {
      num: "2",
      text: "The premium will be deducted from your CPF MediSave account 1 to 2 weeks from your application date.",
    },
    {
      num: "3",
      text: `Your Singlife ${selectedPlanName} coverage kick in once premiums have been successfully deducted.`,
    },
  ];

  const goToMainWebsite = () => {
    window.open(HOME_URL, "_self");
  };

  const trackOnSuccess = (policyData: any) => {
    let paymentTypePayload = "";
    if (+planOverview?.PlanOverViewData?.["MediSaveDeduction"] > 0) {
      paymentTypePayload = "cpf";
    }
    if (+planOverview?.PlanOverViewData?.["totalCashPayble"] > 0) {
      paymentTypePayload += "-creditcard";
    }
    const FA = agentCode
      ? "I have a financial adviser in mind"
      : autoAssignAgent === FinancialAdviser.ARISTOTLE
      ? "Singlife to assign a financial adviser"
      : "No, I do not need a financial adviser";
    const aquisitaionPayload = {
      customer: {
        DOB: policyHolderDetail?.dateOfBirth,
        age: policyHolderDetail?.age,
        gender: policyHolderDetail?.gender,
        marketingOptIn: shieldStarterStep3.personalInfo.stayInTouch,
        servicingMode: FA,
      },
      product: {
        policyID: policyData.policyNumber || "",
        riderpolicyID: policyData?.riderPolicyNumber || "",
        prodID: policyName === SHIELD_STARTER_HELTH_PLUS ? "MSI5,NP5C" : "MSI5",
        prodName: policyName,
      },
      insurance: {
        premium: policyData?.premiumAmount || "",
        promoCode: planOverview?.PlanOverViewData?.promoCode || "",
        discount:
          getPlanValues("promoCodeDiscount") !== "-"
            ? getPlanValues("promoCodeDiscount")
            : "",
        coverType: step1data.whomToBuy === "myself" ? "self" : "child",
        previousInsurer: isEmpty(step1data.existingPlan)
          ? ""
          : step1data.existingPlan,
        paymentType: paymentTypePayload,
      },
    };
    const AA = AAShieldStarter.getInstance();
    let { form, acquisition } = AA.digitalData;
    form.name = "";
    form.error.fieldLabels = [];
    form.error.messages = [];
    form.error.numErrors = "0";
    acquisition = aquisitaionPayload;
    AA.trackPurchasSuccessful({ form, acquisition });
  };

  useEffect(() => {
    if (showPage) trackOnLoad("sss_confirmation_page");
  }, [showPage]);

  const updatePlanSummary = (data: any) => {
    const paymentMethodString = (
      <React.Fragment>
        {`CPF MediSave - ${Helpers.toCurrency(
          Number(data.premiumPaymentmethod?.cpfMediSave) || 0
        )}`}
        <br />
        {`Credit Card - ${Helpers.toCurrency(
          data.premiumPaymentmethod?.creditCard
        )}`}
      </React.Fragment>
    );

    let summarySources = [
      { heading: { text: "Policy number", value: data.policyNumber } },
      { heading: { text: "Plan", value: data.planName } },
      { heading: { text: "Policy term", value: data.policyTerm } },
      { heading: { text: "Premium term", value: data.premiumTerm } },
      {
        heading: {
          text: "Annual Premium with GST",
          value: Helpers.toCurrency(Number(data.premiumAmount) || 0),
        },
      },
    ];

    if (policyName === SHIELD_STARTER_HELTH_PLUS) {
      summarySources.splice(1, 0, {
        heading: { text: "Rider Policy Number", value: data.riderPolicyNumber },
      });
      summarySources.splice(3, 0, {
        heading: { text: "Rider", value: data.rider },
      });
    }

    if (data.promoCode) {
      summarySources = [
        ...summarySources,
        {
          heading: {
            text: "Promo Code (" + data.promoCode + ")",
            value: Helpers.toCurrency(data.promoCodeValue),
          },
        },
        {
          heading: {
            text: "Premium Payment Method",
            value: paymentMethodString,
          },
        },
      ];
    } else {
      summarySources = [
        ...summarySources,
        {
          heading: {
            text: "Premium Payment Method",
            value: paymentMethodString,
          },
        },
      ];
    }

    setPlanSummary(summarySources);
  };

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };

  function getPlanValues(param: string) {
    const prefix = param === "promoCodeDiscount" ? "-" : "";
    return planOverview?.PlanOverViewData?.[param] &&
      planOverview?.PlanOverViewData?.[param] !== "-"
      ? prefix + "S$" + Number(planOverview?.PlanOverViewData[param]).toFixed(2)
      : "-";
  }

  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  const getPolicyStatus = useCallback(async () => {
    try {
      dispatch(setLoadingState(true));
      const pName =
        policyName === SHIELD_STARTER_HELTH_PLUS
          ? "Singlife Shield Starter\nand Health Plus Starter"
          : policyName;
      const queries = `referenceNumber=${paymentRef}`;
      const { data }: any = await checkPaymentSuccess(queries);

      if (isEmpty(data) || data.paymentStatus !== "SUCCESS") {
        history.push(`${ROUTE_PATH.SHIELD_STARTER_REVIEW}?status=unsuccessful`);
        dispatch(setLoadingState(false));
        return;
      }

      setShowPage(true);
      dispatch(updatePaymentStatus(true));

      const policies = {
        policyNumber: data?.policyNumber,
        planName: pName,
        riderPolicyNumber: data?.policyNumberRider,
        rider: "Included",
        policyTerm: "Yearly Renewable",
        premiumTerm: "Yearly Renewable",
        premiumAmount: planOverview?.PlanOverViewData?.subTotalAmount,
        gst: planOverview?.PlanOverViewData?.["gst"],
        promoCode: planOverview?.PlanOverViewData?.promoCode,
        promoCodeValue: getPlanValues("promoCodeDiscount"),
        premiumPaymentmethod: {
          cpfMediSave: +planOverview?.PlanOverViewData?.["MediSaveDeduction"],
          creditCard: +planOverview?.PlanOverViewData?.["totalCashPayble"],
        },
      };

      updatePlanSummary(policies);
      trackOnSuccess(policies);
      Helpers.clearCached();
      dispatch(setLoadingState(false));
    } catch (err) {
      history.push(`${ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR}`);
      dispatch(setLoadingState(false));
    }
  }, []);

  useEffect(() => {
    getPolicyStatus();
  }, []);

  return (
    <>
      {showPage && (
        <MainContainer>
          <FormContainer>
            <FormHeaderContainer>
              <FormHeaderTitleContainer marginHorizontal={"130px"}>
                <Text
                  variant="title"
                  align={"center"}
                  theme={themeDefault}
                >
                  Thank you!
                </Text>
              </FormHeaderTitleContainer>
              <FormHeaderDescriptionContainer>
                <Text
                  variant="title"
                  theme={themeDefault}
                  textClass={HeaderDescriptionCss}
                >
                  Your application has been successfully submitted. <br />
                  We'll let you know the status of your application within 5
                  working days.
                </Text>
              </FormHeaderDescriptionContainer>
            </FormHeaderContainer>
          </FormContainer>

          <FormContentContainer>
            <ULArea>
              {infoData.map((item: any, i: number) => (
                <LIArea key={i}>
                  <NumberArea>{item.num}</NumberArea>
                  <Text variant="base" align="center">
                    {item.text}
                  </Text>
                </LIArea>
              ))}
            </ULArea>
          </FormContentContainer>

          {advisor && (
            <InfoContainer>
              <Icon name="info-black" className="icon-info" />
              <Text variant="description">
                {`${advisor} will be assigned to you as your financial advisor`}
              </Text>
            </InfoContainer>
          )}

          <SectionContainer>
            {planSummary && (
              <ListingContainer margin={"0"}>
                <Text variant="title" margin="0px 0px 50px 0px" color="#883E89">
                  Plan Summary
                </Text>
                {/* <Listing
                sources={planSummary}
                variant="alternate"
                underlineColor="#CCCCCC"
                margin=""
                headingColor="#444444"
              /> */}
                {planSummary.map((entries: any) => {
                  return (
                    <PolicyConfirmationContainer>
                      <span>{entries.heading.text}</span>
                      <span>{entries.heading.value}</span>
                    </PolicyConfirmationContainer>
                  );
                })}
              </ListingContainer>
            )}
          </SectionContainer>

          <FormButtonContainer>
            <Button
              onClick={goToMainWebsite}
              width={"300px"}
              variant={"default"}
              theme={themeDefault}
              label={"Back to home"}
            ></Button>
          </FormButtonContainer>
          <Contactus />
          <CrossSell>
            <Text variant="title" align="center">
              Boost your coverage with these 2 plans
            </Text>
            <Text
              variant="description"
              fontWeight={600}
              color="#8A8988"
              margin="16px auto 0 auto"
              align="center"
            >
              Get a more holistic protection to safeguard your financial health
            </Text>
            <Items>
              <Item>
                <Text variant="title" fontSize="20px">
                  Singlife CareShield Standard and Plus
                </Text>
                <Tags>
                  <Tag>death</Tag>
                  <Tag>disability</Tag>
                </Tags>
                <Text variant="description" fontSize="14px" fontWeight={500}>
                  Two government-approved supplement plans that enhance your
                  CareShield Life or ElderShield payouts so you can get the care
                  you need should you become severely disabled.
                </Text>
                <Button
                  margin="24px 0 0"
                  onClick={() => window.open(UTM_CARESHIELD_URL, "_blank")}
                  variant={"default"}
                  theme={themeDefault}
                  label={"Find out how"}
                ></Button>
              </Item>
              <Item>
                <Text textClass={addLine} variant="title" fontSize="20px">
                  {"Singlife Cancer Cover Plus \n\n"}
                </Text>
                <Tags>
                  <Tag>death</Tag>
                  <Tag>critical illness</Tag>
                </Tags>
                <Text
                  textClass={addLine}
                  variant="description"
                  fontSize="14px"
                  fontWeight={500}
                >
                  {
                    "A medical plan that protects against hefty medical bills from cancer treatments and complements your existing medical insurance coverage. \n\n"
                  }
                </Text>
                <Button
                  margin="24px 0 0"
                  onClick={() => window.open(UTM_CANCER_URL, "_blank")}
                  variant={"default"}
                  theme={themeDefault}
                  label={"Find out how"}
                ></Button>
              </Item>
            </Items>
          </CrossSell>
        </MainContainer>
      )}
    </>
  );
};

export default Confirmation;

const Container = styled.div`
  position: relative;
  margin: 0 auto;
  display: block;
  @media screen and (min-width: 768px) {
    margin: 0 auto;
    max-width: 792px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
`;

const SectionContainer = styled.div<{ margin?: string; width?: string }>`
  background-color: #ffffff;
  border-radius: 24px;
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  transition: all 0.2s ease;
  margin: 48px auto auto;
  padding: 24px 16px;
  scroll-margin-top: 150px;
  white-space: break-spaces;

  @media screen and (min-width: 768px) {
    max-width: 588px;
    margin: auto;
    padding: 24px;
  }
  @media screen and (max-width: 768px) {
    // margin: auto 24px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }

  @media screen and (max-width: 588px) {
    // margin: auto 24px;
  }
`;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
`;

const FormContainer = styled.div<FormContainerProps>`
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
`;

const ListingContainer = styled.div<FormContainerProps>`
  width: 100%;
  margin: 0 auto;
  @media screen and (min-width: 768px) {
    max-width: 792px;
    margin: ${(props) => (props.margin ? props.margin : "150px auto 0 auto")};
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
  @media screen and (max-width: 588px) {
    max-width: 327px;
  }
`;

const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 48px;
  padding: 0px 10px;
  @media screen and (min-width: 768px) {
  }
  @media screen and (max-widh: 588px) {
    max-width: 327px;
  }
`;

const FormContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  column-gap: 30px;
  margin-bottom: 30px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin: 0 20px 16px 20px;
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 0;
  }
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 64px;
  column-gap: 40px;
  @media screen and (max-width: 767px) {
    column-gap: 0;
    row-gap: 10px;
    margin: 64px auto 0;
    flex-direction: column;
    align-items: center;
    max-width: 327px;
    width: 100%;
  }
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  @media screen and (min-width: 768px) {
    // font-weight: 600;
  }
`;

// stems area
const ULArea = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  isolation: isolate;

  @media screen and (max-width: 588px) {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: auto 20px;
    &:after {
      content: "";
      border: 1px dashed #d8d8d8;
      position: absolute;
      top: 38px;
      bottom: 52px;
      left: 28px;
      z-index: -1;
    }
  }
`;

const LIArea = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 16px;
  flex-basis: 27%;
  border-radius: 24px;
  position: relative;
  &:last-child span:after {
    display: none;
  }

  @media screen and (max-width: 588px) {
    flex-direction: row;
    span {
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }
    p {
      width: 100%;
      align-items: center;
    }
    span:after {
      display: none;
    }
  }
`;

const NumberArea = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  background: #000;
  color: #fff;
  width: 45px;
  height: 45px;
  justify-content: center;
  border-radius: 50%;
  &:after {
    content: "...";
    position: absolute;
    font-size: 72px;
    top: 10px;
    right: -18px;
    z-index: -1;
    width: 32%;
    letter-spacing: 48px;
  }
  @media screen and (max-width: 588px) {
    position: relative;
    justify-content: flex-start;
    align-items: self-end;
    width: 28.4px;
    height: 24px;
    font-size: 16px;
    text-align: center;
    margin-top: -20px;
    &:before {
      content: "";
      flex-grow: 2;
      height: 2px;
      width: 100%;
    }
  }
`;

// info styles
const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 24px 36px;
  background-color: #ffffff;
  border-radius: 24px;
  margin: 48px 0 0;
  column-gap: 16px;
`;

const PolicyConfirmationContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  padding-bottom: 24px;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  & span:nth-child(1) {
    flex-wrap: wrap;
    width: 60%;
    font-weight: 600;
    font-size: 14px;
  }
  & span:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    font-weight: 400;
    font-size: 14px;
  }
`;

// Cross Sell
const CrossSell = styled.div`
  border-top: 1px solid #d8d8d8;
  padding-top: 64px;
`;

const Items = styled.div`
  margin-top: 48px;
  display: grid;
  column-gap: 24px;
  grid-template-columns: 1fr;
  row-gap: 24px;
  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Item = styled.div`
  display: flex;
  border-radius: 16px;
  background: #fff;
  padding: 24px;
  flex-direction: column;
`;

const Tags = styled.div`
  display: flex;
  gap: 8px;
  margin: 16px 0;
`;

const Tag = styled.div`
  padding: 4px 8px;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 600;
`;

const addLine = css`
  white-space: break-spaces;
`;

export interface FormContainerProps {
  margin?: string;
}

export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}
